import React, { useState } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import { InputField } from '../../atoms'
import ActionDialog from '../action-dialog'

const ModalDeleteUser = ({ open, handleClose, i18n, name, handleOnClickDelete }) => {
  const [disableButton, setDisableButton] = useState(true)

  function handleOnChange(value) {
    if (value === name) {
      setDisableButton(false)
    } else {
      setDisableButton(true)
    }
  }

  // Devuelve la petición del padre: spinner en el botón y el padre cierra el modal cuando ha ido bien
  function handleDeleleButton() {
    return Promise.resolve(handleOnClickDelete()).then(() => setDisableButton(true))
  }

  return (
    <ActionDialog
      open={open}
      title={`${i18n.modalDeleteUser.removeUser} ${name}`}
      onClose={handleClose}
      onConfirm={handleDeleleButton}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalDeleteUser.remove}
      confirmColor="error"
      confirmDisabled={disableButton}
      maxWidth="xs"
    >
      <S.Body>
        <label>{i18n.modalDeleteUser.enterCandidateName}</label>
        <InputField handleOnChange={handleOnChange} placeholder={i18n.modalDeleteUser.writeCandidateName} name="message" />
      </S.Body>
    </ActionDialog>
  )
}

ModalDeleteUser.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  name: PropTypes.string,
  handleOnClickDelete: PropTypes.func
}

const enharce = compose(withI18n)

export default enharce(ModalDeleteUser)
